export interface Testimonial {
  id: string;
  name: string;
  role: string;
  category: "BNSSA" | "MNS" | "Employeur";
  content: string;
  rating: number;
  avatar: string;
  city: string;
}

export const testimonials: Testimonial[] = [
  {
    id: "t1",
    name: "Sophie M.",
    role: "BNSSA — Piscine Municipale",
    category: "BNSSA",
    content:
      "Grâce à Emplois BNSSA & MNS, j'ai trouvé mon poste en moins de 2 semaines ! La plateforme est claire, les offres sont ciblées et le processus de candidature est vraiment simple. Je recommande à tous les professionnels de la surveillance aquatique.",
    rating: 5,
    avatar: "SM",
    city: "Lyon",
  },
  {
    id: "t2",
    name: "Julien R.",
    role: "Maître Nageur Sauveteur CDI",
    category: "MNS",
    content:
      "Après 3 mois de recherche difficile sur des sites généralistes, j'ai trouvé mon CDI MNS en 10 jours sur cette plateforme spécialisée. Les filtres par type de contrat et par région sont vraiment efficaces !",
    rating: 5,
    avatar: "JR",
    city: "Bordeaux",
  },
  {
    id: "t3",
    name: "Marie-Claire D.",
    role: "Responsable RH — Centre Aquatique",
    category: "Employeur",
    content:
      "En tant que recruteur, cette plateforme nous fait gagner un temps précieux. Tous les candidats ont les diplômes requis. Les profils sont qualifiés et la gestion des candidatures est intuitive. Indispensable pour nos recrutements aquatiques.",
    rating: 5,
    avatar: "MD",
    city: "Paris",
  },
  {
    id: "t4",
    name: "Thomas B.",
    role: "BNSSA Auto-Entrepreneur",
    category: "BNSSA",
    content:
      "La rubrique auto-entrepreneur est une vraie innovation ! Je gère mes missions ponctuelles et je fixe mes tarifs. J'ai doublé mon activité grâce aux mises en relation de qualité sur cette plateforme.",
    rating: 4,
    avatar: "TB",
    city: "Nice",
  },
  {
    id: "t5",
    name: "Amandine L.",
    role: "MNS en Formation BPJEPS",
    category: "MNS",
    content:
      "La section Formation m'a permis de trouver le bon organisme pour mon BPJEPS AAN. Les informations sont détaillées, les avis sont honnêtes et le formulaire d'inscription est rapide. Merci à toute l'équipe !",
    rating: 5,
    avatar: "AL",
    city: "Toulouse",
  },
  {
    id: "t6",
    name: "Pierre-Antoine V.",
    role: "Directeur — Complexe Aquatique",
    category: "Employeur",
    content:
      "Nous recrutons exclusivement sur cette plateforme depuis 1 an. La qualité des candidatures est incomparable avec les sites généralistes. Nos postes sont pourvus 3 fois plus vite. Une référence dans le milieu aquatique.",
    rating: 5,
    avatar: "PV",
    city: "Rennes",
  },
];

export interface FAQ {
  id: string;
  question: string;
  answer: string;
  category: "Candidats" | "Employeurs" | "Formation" | "BNSSA" | "MNS";
}

export const faqs: FAQ[] = [
  {
    id: "faq1",
    question: "Quelle est la différence entre le BNSSA et le diplôme de Maître Nageur ?",
    answer:
      "Le BNSSA (Brevet National de Sécurité et de Sauvetage Aquatique) est une qualification qui autorise uniquement la surveillance des bassins. Il ne permet pas d'enseigner la natation. Le diplôme de Maître Nageur Sauveteur (BPJEPS AAN ou BEESAN) est un diplôme d'État de niveau 4 ou 5 qui permet d'enseigner la natation, d'encadrer des activités aquatiques ET d'assurer la surveillance. Les MNS ont donc un champ d'exercice bien plus large.",
    category: "BNSSA",
  },
  {
    id: "faq2",
    question: "Comment renouveler son BNSSA ?",
    answer:
      "Le BNSSA doit être révisé tous les 5 ans. La révision comprend une mise à jour des compétences PSE1 (Premiers Secours en Équipe niveau 1) et un recyclage pratique. Vous pouvez trouver des organismes de révision agréés dans notre section Formation. Il est conseillé d'anticiper le renouvellement 6 mois avant l'expiration.",
    category: "BNSSA",
  },
  {
    id: "faq3",
    question: "Puis-je travailler comme BNSSA en tant qu'auto-entrepreneur ?",
    answer:
      "Oui, c'est tout à fait possible. En tant que BNSSA auto-entrepreneur, vous pouvez proposer vos services de surveillance à des établissements privés (piscines de résidence, clubs, événements). Vous fixez votre tarif horaire. Notez cependant que certains établissements publics ne peuvent pas recourir à des auto-entrepreneurs pour des missions de surveillance réglementées.",
    category: "BNSSA",
  },
  {
    id: "faq4",
    question: "Comment s'inscrire pour postuler à une offre ?",
    answer:
      "L'inscription est gratuite et rapide. Cliquez sur \"Créer un compte\" en haut de la page, remplissez le formulaire avec vos informations, validez votre email. Une fois connecté, vous pouvez postuler directement depuis chaque fiche d'offre en joignant votre CV et lettre de motivation.",
    category: "Candidats",
  },
  {
    id: "faq5",
    question: "Quels documents dois-je fournir pour postuler ?",
    answer:
      "Pour postuler, vous aurez besoin de : votre CV actualisé (format PDF recommandé), une lettre de motivation, la copie de votre diplôme BNSSA ou MNS, la copie de votre carte professionnelle en cours de validité, votre attestation PSE1 à jour. Ces documents peuvent être sauvegardés dans votre profil pour postuler rapidement.",
    category: "Candidats",
  },
  {
    id: "faq6",
    question: "Comment publier une offre d'emploi en tant que recruteur ?",
    answer:
      "Pour publier une offre, créez un compte recruteur gratuit, accédez au back-office depuis votre tableau de bord, cliquez sur \"Nouvelle offre\" et remplissez le formulaire complet. Votre offre sera vérifiée puis publiée dans les 24h. La première offre est gratuite.",
    category: "Employeurs",
  },
  {
    id: "faq7",
    question: "Quels sont les débouchés après un BPJEPS AAN ?",
    answer:
      "Le BPJEPS AAN ouvre de nombreuses portes : MNS en piscine municipale ou privée, animateur d'activités aquatiques (aquagym, aquabike, bébés nageurs), entraîneur en club de natation, responsable d'établissement aquatique, formateur en natation. Les perspectives d'évolution incluent le passage au BEESAN ou des fonctions de direction.",
    category: "MNS",
  },
  {
    id: "faq8",
    question: "Le site est-il gratuit pour les candidats ?",
    answer:
      "Oui, le site est entièrement gratuit pour les candidats. Inscription, consultation des offres, candidature en ligne et accès au catalogue de formations sont sans frais. Seuls les recruteurs et organismes de formation disposent d'offres premium pour mettre en avant leurs annonces.",
    category: "Candidats",
  },
  {
    id: "faq9",
    question: "Quelle est la durée d'une formation BPJEPS AAN ?",
    answer:
      "La formation BPJEPS AAN dure généralement entre 12 et 18 mois en alternance. Elle comprend des périodes en centre de formation et des stages pratiques en établissement. Le volume horaire est d'environ 900 heures. La formation peut être financée via le CPF, Pôle Emploi ou les OPCO.",
    category: "Formation",
  },
  {
    id: "faq10",
    question: "Comment financer ma formation MNS ou BNSSA ?",
    answer:
      "Plusieurs dispositifs existent : le CPF (Compte Personnel de Formation) pour les salariés et demandeurs d'emploi, les aides de Pôle Emploi (AIF, POEI), le financement par les OPCO pour les salariés, les bourses régionales, les contrats d'apprentissage ou de professionnalisation. Consultez notre section Formation pour des informations sur le financement de chaque cursus.",
    category: "Formation",
  },
];
